import { $, $$, closest } from 'utils/dom';
import { datePickerConfig, dateFormat } from './datePickerConfig';
import TinyDatePicker from 'tiny-date-picker';
import { PictureLazerLoader } from 'modules/lazer-loader';
import Shower from 'modules/shower';
import { parseDateToISO } from 'utils/helper';

const lang = document.documentElement.lang.substring(0, 2);
const months =
  lang === 'de'
    ? [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ]
    : [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];

class CalendarFilter {
  constructor(container = document) {
    this.container = container;
    this.events = $$('.event-list-item', container);
    this.eventsContainer = $('.calendar__event-wrapper', container);
    this.formatCheckboxWrapper = [];
    this.audienceCheckboxWrapper = [];
    this.languageCheckboxWrapper = [];
    this.exhibitionCheckboxWrapper = [];
    this.eventBreaks = $$('.event-list-item--break', this.eventsContainer).sort(
      (a, b) => a.dataset.sorting - b.dataset.sorting
    );
    this.formatFilter = {};
    this.audienceFilter = {};
    this.languageFilter = {};
    this.exhibitionFilter = {};
    this.dateFilter = null;
    this.eventDates = new Set();
    this.dp = null;
    this.today = new Date();
    this.visibleAudienceTags = new Set();
    this.visibleFormatTags = new Set();
    this.visibleLanguageTags = new Set();
    this.visibleExhibitionTags = new Set();
  }

  initShower() {
    const handler = $('.calendar__filter-toggle-btn', this.container);
    const target = $('.calendar__shower-wrapper', this.container);

    new Shower({
      target,
      handler,
      easing: 'ease',
      duration: 250,
      initOpened: false,
      openClassName: 'is-open',
    }).init();
  }

  insertFilters() {
    const DomParser = new DOMParser();
    const filterTemplate = (id, label) =>
      `<div class="checkbox-wrapper"><input type="checkbox" id="${id}"><label for="${id}">${label}</label></div>`;
    const formatFilter = new Set();
    const audienceFilter = new Set();
    const languageFilter = new Set();
    const exhibitionFilter = new Set();

    this.events.forEach(event => {
      const filterData = JSON.parse(event.dataset.filter);
      filterData.formatTags.forEach(tag => formatFilter.add(tag));
      filterData.audienceTags.forEach(tag => audienceFilter.add(tag));
      filterData.languageTags.forEach(tag => languageFilter.add(tag));
      filterData.exhibitionTags.forEach(tag => exhibitionFilter.add(tag));
    });

    const formatFilterDomString = [...formatFilter].reduce(
      (domString, filter) =>
        (domString += filterTemplate(
          Math.floor(Math.random() * 100000),
          filter
        )),
      ''
    );
    const audienceFilterDomString = [...audienceFilter].reduce(
      (domString, filter) =>
        (domString += filterTemplate(
          Math.floor(Math.random() * 100000),
          filter
        )),
      ''
    );

    const languageFilterDomString = [...languageFilter].reduce(
      (domString, filter) =>
        (domString += filterTemplate(
          Math.floor(Math.random() * 100000),
          filter
        )),
      ''
    );

    const exhibitionFilterDomString = [...exhibitionFilter].reduce(
      (domString, filter) =>
        (domString += filterTemplate(
          Math.floor(Math.random() * 100000),
          filter
        )),
      ''
    );

    const formatFilterContainer = $(
      '.checkbox-wrapper-container--format',
      this.container
    );
    const audienceFilterContainer = $(
      '.checkbox-wrapper-container--audience',
      this.container
    );
    const languageFilterContainer = $(
      '.checkbox-wrapper-container--language',
      this.container
    );
    const exhibitionFilterContainer = $(
      '.checkbox-wrapper-container--exhibition',
      this.container
    );

    this.formatCheckboxWrapper = [
      ...DomParser.parseFromString(formatFilterDomString, 'text/html').body
        .childNodes,
    ];
    this.audienceCheckboxWrapper = [
      ...DomParser.parseFromString(audienceFilterDomString, 'text/html').body
        .childNodes,
    ];
    this.languageCheckboxWrapper = [
      ...DomParser.parseFromString(languageFilterDomString, 'text/html').body
        .childNodes,
    ];
    this.exhibitionCheckboxWrapper = [
      ...DomParser.parseFromString(exhibitionFilterDomString, 'text/html').body
        .childNodes,
    ];

    this.formatCheckboxWrapper.forEach(cb =>
      formatFilterContainer.insertAdjacentElement('beforeend', cb)
    );
    this.audienceCheckboxWrapper.forEach(cb =>
      audienceFilterContainer.insertAdjacentElement('beforeend', cb)
    );
    this.languageCheckboxWrapper.forEach(cb =>
      languageFilterContainer.insertAdjacentElement('beforeend', cb)
    );
    this.exhibitionCheckboxWrapper.forEach(cb =>
      exhibitionFilterContainer.insertAdjacentElement('beforeend', cb)
    );

    // hide language filter fieldset if filter is empty
    if (!this.languageCheckboxWrapper.length)
      languageFilterContainer.parentElement.classList.add('is-hidden');
  }

  bindEvents() {
    [
      ...this.formatCheckboxWrapper,
      ...this.audienceCheckboxWrapper,
      ...this.languageCheckboxWrapper,
      ...this.exhibitionCheckboxWrapper,
    ].forEach(checkbox => {
      checkbox.addEventListener('change', e => {
        this.setActiveFilter();
        this.updateVisibleEvents(e);
      });
    });

    $('.calendar__filter-reset', this.container).addEventListener('click', () =>
      this.resetAllFilter()
    );

    const filterContainer = $('.calendar__filter');

    filterContainer.addEventListener(
      'mouseenter',
      () => (this.eventsContainer.style.willChange = 'transform, opacity')
    );

    filterContainer.addEventListener(
      'mouseleave',
      () => (this.eventsContainer.style.willChange = 'auto')
    );
  }

  resetAllFilter() {
    [
      ...this.formatCheckboxWrapper,
      ...this.audienceCheckboxWrapper,
      ...this.languageCheckboxWrapper,
      ...this.exhibitionCheckboxWrapper,
    ].forEach(w => {
      const cb = $('input', w);
      cb.checked = false;
      cb.disabled = false;
      cb.parentNode.classList.remove('is-striked');
    });
    this.dateFilter = null;
    this.setActiveFilter();
    this.updateVisibleEvents();
  }

  setActiveFilter() {
    this.formatCheckboxWrapper.forEach(wrapper => {
      this.formatFilter[$('label', wrapper).innerText] = $(
        'input',
        wrapper
      ).checked;
    });

    this.audienceCheckboxWrapper.forEach(wrapper => {
      this.audienceFilter[$('label', wrapper).innerText] = $(
        'input',
        wrapper
      ).checked;
    });
    this.languageCheckboxWrapper.forEach(wrapper => {
      this.languageFilter[$('label', wrapper).innerText] = $(
        'input',
        wrapper
      ).checked;
    });
    this.exhibitionCheckboxWrapper.forEach(wrapper => {
      this.exhibitionFilter[$('label', wrapper).innerText] = $(
        'input',
        wrapper
      ).checked;
    });
  }

  getEventDates() {
    this.events.forEach(event => {
      this.eventDates.add(new Date($('time', event).dateTime).toDateString());
    });
  }

  filterEmpty() {
    const formatFilterEmpty = !Object.keys(this.formatFilter).some(
      key => this.formatFilter[key]
    );
    const audienceFilterEmpty = !Object.keys(this.audienceFilter).some(
      key => this.audienceFilter[key]
    );
    const languageFilterEmpty = !Object.keys(this.languageFilter).some(
      key => this.languageFilter[key]
    );
    const exhibitionFilterEmpty = !Object.keys(this.exhibitionFilter).some(
      key => this.exhibitionFilter[key]
    );

    return {
      formatFilterEmpty,
      audienceFilterEmpty,
      languageFilterEmpty,
      exhibitionFilterEmpty,
    };
  }

  updateVisibleEvents(event) {
    // hides events
    this.eventsContainer.classList.add('is-updating');

    let eventCount = 0;
    let eventBreakCount = 0;
    let lastMonth = '';
    let lastDate = '';

    // wait until animation hides the elements, do stuff, then reveal it again
    setTimeout(() => {
      // reset visible format tags, so we can refill them again in the loop
      this.visibleFormatTags.clear();
      this.visibleAudienceTags.clear();
      this.visibleLanguageTags.clear();
      this.visibleExhibitionTags.clear();

      const $eventWrapper = $('.calendar__event-wrapper', this.container);
      const $$monthYearHeadings = $$(
        '.calendar__event-date-heading',
        $eventWrapper
      );

      // reset all Month + Year Headings
      $$monthYearHeadings.forEach($heading =>
        $eventWrapper.removeChild($heading)
      );

      // hide all eventBreaks so we can reveal only the necessary ones
      this.eventBreaks.forEach(ev => ev.classList.add('is-hidden'));

      this.events.forEach((event, i) => {
        const timeContainer = $('time', event);
        const timeStamp = timeContainer.getAttribute('datetime');
        const eventDate = new Date(parseDateToISO(timeStamp));
        const eventDateString = eventDate.toDateString();
        const { formatTags, audienceTags, languageTags, exhibitionTags } =
          JSON.parse(event.dataset.filter || {});

        // check if the filters can be ignored (when no filter is active)
        const {
          formatFilterEmpty,
          audienceFilterEmpty,
          languageFilterEmpty,
          exhibitionFilterEmpty,
        } = this.filterEmpty();

        // check if the filters are being passed
        const passesFormatFilter =
          formatFilterEmpty || formatTags.some(tag => this.formatFilter[tag]);
        const passesAudienceFilter =
          audienceFilterEmpty ||
          !Object.keys(this.audienceFilter).some(
            key => this.audienceFilter[key] && !audienceTags.includes(key)
          );
        const passesLanguageFilter =
          languageFilterEmpty ||
          !Object.keys(this.languageFilter).some(
            key => this.languageFilter[key] && !languageTags.includes(key)
          );
        const passesExhibitionFilter =
          exhibitionFilterEmpty ||
          !Object.keys(this.exhibitionFilter).some(
            key => this.exhibitionFilter[key] && !exhibitionTags.includes(key)
          );

        const passesDateFilter =
          this.dateFilter === null || this.dateFilter === eventDateString;

        if (
          passesDateFilter &&
          passesFormatFilter &&
          passesAudienceFilter &&
          passesLanguageFilter &&
          passesExhibitionFilter
        ) {
          eventCount++;
          event.classList.remove('is-hidden');

          // add "active" Tags into the set of supposed-to-be visible Filters
          formatTags.forEach(tag => this.visibleFormatTags.add(tag));
          audienceTags.forEach(tag => this.visibleAudienceTags.add(tag));
          languageTags.forEach(tag => this.visibleLanguageTags.add(tag));
          exhibitionTags.forEach(tag => this.visibleExhibitionTags.add(tag));

          // hide date if it is the same as the one before and there is no break in between
          const timeDate = $('.event-list-item__date', event);
          const timeMonth = $('.event-list-item__month', event);
          const timeDay = $('.event-list-item__day', event);
          const dateString = eventDate.toISOString().split('T')[0];

          if (
            dateString === lastDate &&
            (eventCount !== 3 || this.eventBreaks[eventBreakCount] == null)
          ) {
            [timeDate, timeMonth, timeDay].forEach(el =>
              el.classList.add('visibility-hidden')
            );
          } else {
            [timeDate, timeMonth, timeDay].forEach(el =>
              el.classList.remove('visibility-hidden')
            );
            lastDate = dateString;
          }

          // add eventBreak after 3 Events
          if (eventCount === 3) {
            const eventBreak = this.eventBreaks[eventBreakCount];
            if (eventBreak !== undefined) {
              eventBreak.classList.remove('is-hidden');
              event.parentNode.insertBefore(eventBreak, event);
            }
            eventCount = 0;
            eventBreakCount++;
          }

          // add Month + Year Headings
          const eventMonthIdx = eventDate.getMonth();
          if (eventMonthIdx !== lastMonth && i !== 0) {
            const el = document.createElement('h2');
            el.innerText = `${
              months[eventMonthIdx]
            } ${eventDate.getFullYear()}`;
            el.classList.add('calendar__event-date-heading');
            event.parentNode.insertBefore(el, event);
          }
          lastMonth = eventMonthIdx;
        } else {
          event.classList.add('is-hidden');
        }
      });

      if (event) {
        const groupNode = closest(event.target, '.calendar__filter-group');
        if (groupNode.classList.contains('calendar__filter-group--format')) {
          this.hideUnusedFilter('format');
        }
        if (groupNode.classList.contains('calendar__filter-group--audience')) {
          this.hideUnusedFilter('audience');
        }

        if (groupNode.classList.contains('calendar__filter-group--language')) {
          this.hideUnusedFilter('language');
        }

        if (
          groupNode.classList.contains('calendar__filter-group--exhibition')
        ) {
          this.hideUnusedFilter('exhibition');
        }
      }

      // reveal events again
      this.eventsContainer.classList.remove('is-updating');
    }, 75);
  }

  disableUselessOptions(wrappers, tags, onlyEnable = false) {
    wrappers.forEach(wrapper => {
      const box = $('input', wrapper);
      if (!tags.has($('label', wrapper).innerText)) {
        if (!onlyEnable) {
          box.checked = false;
          box.disabled = true;
          box.parentNode.classList.add('is-striked');
        }
      } else {
        box.parentNode.classList.remove('is-striked');
        box.disabled = false;
      }
    });
  }

  hideUnusedFilter(filterGroup) {
    if (filterGroup === 'format') {
      this.disableUselessOptions(
        this.audienceCheckboxWrapper,
        this.visibleAudienceTags
      );
      this.disableUselessOptions(
        this.languageCheckboxWrapper,
        this.visibleLanguageTags
      );
      this.disableUselessOptions(
        this.exhibitionCheckboxWrapper,
        this.visibleExhibitionTags
      );
      this.disableUselessOptions(
        this.formatCheckboxWrapper,
        this.visibleFormatTags,
        true
      );
    } else if (filterGroup === 'audience') {
      const formatFilterTags = new Set();
      const languageFilterTags = new Set();
      const exhibitionFilterTags = new Set();

      this.disableUselessOptions(
        this.formatCheckboxWrapper,
        this.visibleFormatTags
      );
      this.disableUselessOptions(
        this.languageCheckboxWrapper,
        this.visibleLanguageTags
      );
      this.disableUselessOptions(
        this.audienceCheckboxWrapper,
        this.visibleAudienceTags
      );
      this.disableUselessOptions(
        this.exhibitionCheckboxWrapper,
        this.visibleExhibitionTags
      );

      // We dont want to only show the filters with items that are currently visible but all items that could be visible
      // This variable will hold the format-tags of all items that pass the audience filter
      this.events.forEach(event => {
        const { audienceFilterEmpty } = this.filterEmpty();
        const { formatTags, audienceTags, languageTags, exhibitionTags } =
          JSON.parse(event.dataset.filter || {});
        const passesAudienceFilter =
          audienceFilterEmpty ||
          !Object.keys(this.audienceFilter).some(
            key => this.audienceFilter[key] && !audienceTags.includes(key)
          );

        passesAudienceFilter &&
          formatTags.forEach(tag => formatFilterTags.add(tag)) &&
          languageTags.forEach(tag => languageFilterTags.add(tag)) &&
          exhibitionTags.forEach(tag => exhibitionFilterTags.add(tag));
      });
    } else if (filterGroup === 'language') {
      const formatFilterTags = new Set();
      const audienceFilterTags = new Set();
      const exhibitionFilterTags = new Set();

      this.disableUselessOptions(
        this.formatCheckboxWrapper,
        this.visibleFormatTags
      );
      this.disableUselessOptions(
        this.languageCheckboxWrapper,
        this.visibleLanguageTags
      );
      this.disableUselessOptions(
        this.audienceCheckboxWrapper,
        this.visibleAudienceTags
      );
      this.disableUselessOptions(
        this.exhibitionCheckboxWrapper,
        this.visibleExhibitionTags
      );

      this.events.forEach(event => {
        const { languageFilterEmpty } = this.filterEmpty();
        const { formatTags, audienceTags, languageTags, exhibitionTags } =
          JSON.parse(event.dataset.filter || {});
        const passesLanguageFilter =
          languageFilterEmpty ||
          !Object.keys(this.languageFilter).some(
            key => this.languageFilter[key] && !languageTags.includes(key)
          );

        passesLanguageFilter &&
          formatTags.forEach(tag => formatFilterTags.add(tag)) &&
          audienceTags.forEach(tag => audienceFilterTags.add(tag)) &&
          exhibitionTags.forEach(tag => exhibitionFilterTags.add(tag));
      });
    } else if (filterGroup === 'exhibition') {
      const formatFilterTags = new Set();
      const audienceFilterTags = new Set();
      const languageFilterTags = new Set();

      this.disableUselessOptions(
        this.formatCheckboxWrapper,
        this.visibleFormatTags
      );
      this.disableUselessOptions(
        this.languageCheckboxWrapper,
        this.visibleLanguageTags
      );
      this.disableUselessOptions(
        this.audienceCheckboxWrapper,
        this.visibleAudienceTags
      );
      this.disableUselessOptions(
        this.exhibitionCheckboxWrapper,
        this.visibleExhibitionTags
      );

      this.events.forEach(event => {
        const { exhibitionFilterEmpty } = this.filterEmpty();
        const { formatTags, audienceTags, languageTags, exhibitionTags } =
          JSON.parse(event.dataset.filter || {});
        const passesExhibitionFilter =
          exhibitionFilterEmpty ||
          !Object.keys(this.exhibitionFilter).some(
            key => this.exhibitionFilter[key] && !exhibitionTags.includes(key)
          );

        passesExhibitionFilter &&
          formatTags.forEach(tag => formatFilterTags.add(tag)) &&
          audienceTags.forEach(tag => audienceFilterTags.add(tag)) &&
          languageTags.forEach(tag => languageFilterTags.add(tag));
      });
    }
  }

  initDatePicker() {
    let keydownAllowed = true;
    const self = this;
    this.dp = TinyDatePicker($('.calendar-container', this.container), {
      mode: 'dp-permanent',
      min: this.today,
      format(date) {
        return dateFormat(date);
      },
      lang: datePickerConfig,
      dayOffset: 1,
      dateClass(date) {
        return self.eventDates.has(date.toDateString()) ? 'has-event' : '';
      },
    })
      .on('select', (_, dp) => {
        // because 'select' uses multiple events and will be fired twice when
        // navigating with keyboard, we have to add a delay
        if (keydownAllowed) {
          keydownAllowed = false;
          if (this.dateFilter === dp.state.selectedDate.toDateString()) {
            this.dateFilter = null;
          } else {
            this.dateFilter = dp.state.selectedDate.toDateString();
          }
          setTimeout(() => (keydownAllowed = true), 50);
          this.setActiveFilter();
          this.updateVisibleEvents();
        }
      }) // re-queueing necessary
      .on('statechange', () => setTimeout(() => this.setDateAriaLabels(), 0));

    // set aria labels and make tabbable
    $('.dp', this.container).tabIndex = 0;
    $('.dp', this.container).setAttribute(
      'aria-label',
      lang === 'de'
        ? 'Kalender. Benutze die Pfeiltasten um den Kalender zu bedienen'
        : 'Calendar. Use the arrow-keys to use this Calendar'
    );
  }

  setDateAriaLabels() {
    $$('button.dp-day', this.container).forEach(dayBtn => {
      const date = new Date(Number(dayBtn.dataset.date));
      dayBtn.setAttribute('aria-label', date.toDateString());
    });
  }

  init() {
    this.insertFilters();
    this.initShower();
    this.bindEvents();
    this.setActiveFilter();
    this.getEventDates();
    this.updateVisibleEvents();
    this.initDatePicker();

    new PictureLazerLoader({
      targets: $$('picture', this.container),
      cb: () => {},
    }).init();
  }
}

const $$eventCalendars = $$('.event-calendar');
if ($$eventCalendars.length !== 0) {
  $$eventCalendars.forEach(calendar => new CalendarFilter(calendar).init());
}

// Todo: clean up...
// Todo: batch read and write processes and prevent layout-thrashing and clean up.
